/**
 * `?register=1` on an event or course page opens its registration (ticket
 * selection first) as soon as the page knows the person is not registered.
 * Every "Register" button outside the page links here, and sign-in returns
 * here, so registration starts the same way from everywhere.
 */
export const REGISTER_PARAM = 'register';

export function registerHref(type: 'event' | 'course', id: string): string {
  return `${type === 'event' ? '/event' : '/courses'}/${id}?${REGISTER_PARAM}=1`;
}

/** The current page's path + query with `?register=1` added (sign-in return target). */
export function currentPathWithRegister(): string {
  const url = new URL(window.location.href);
  url.searchParams.set(REGISTER_PARAM, '1');
  return url.pathname + url.search;
}

/** Drops `?register=1` from the address bar, so a reload does not reopen registration. */
export function clearRegisterParam(): void {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(REGISTER_PARAM)) return;
  url.searchParams.delete(REGISTER_PARAM);
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
}
